export var ActionBarSize;
(function (ActionBarSize) {
    ActionBarSize["Large"] = "large";
    ActionBarSize["Medium"] = "medium";
    ActionBarSize["Small"] = "small";
})(ActionBarSize || (ActionBarSize = {}));
